import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { NavDropDownStyled } from 'layouts/header/nav/navDropDown.styles';
import { NavDropDownContentColumnStyled } from 'layouts/header/nav/navDropDownContent.styles';
import { NavHeadingStyles } from 'layouts/header/nav/navHeading.styles';
import {
  NavHeadingWithButtonStyles,
  NavLinkStyled,
  CenteredText
} from './create-account-menu.styles';

/**
 * This menu is only intended to visually align with <EditUserMenu />. It has no routing functionality, and is strictly cosmetic.
 * It is used in the CreateUser and CreateAdmin flows to provide a consistent user interface.
 *
 * @component
 *
 * @returns {JSX.Element} The rendered CreateAccountMenu component.
 */
const CreateAccountMenu: FC = () => {
  const { t } = useTranslation();
  return (
    <NavDropDownStyled
      data-testid="create-user-menu"
      data-analytics-id="create-user-menu"
    >
      <NavDropDownContentColumnStyled>
        <>
          <NavHeadingStyles>
            <NavHeadingWithButtonStyles>
              <p>{t?.('common_profile')}</p>
            </NavHeadingWithButtonStyles>
          </NavHeadingStyles>
          <NavLinkStyled $topMenu={false} $active={true}>
            <CenteredText>{t?.('account_details')}</CenteredText>
          </NavLinkStyled>
        </>
      </NavDropDownContentColumnStyled>
    </NavDropDownStyled>
  );
};

export default CreateAccountMenu;
